/**
    我的采购单
**/
<template>
  <div class="rightaside_content">
    <div class="main_top">
      <h3 class="headerTitle">招标订单列表</h3>
      <div class="search">
        <el-input
          v-model="form.title"
          placeholder="请输入采购标题"
          class="ipt"
          @keyup.enter.native="Handlesearch()"
        ></el-input>
        <el-button class="btn" @click="Handlesearch()">查询</el-button>
      </div>
    </div>

    <el-tabs
      type="border-card"
      v-loading="loading"
      class="tabs"
      v-model="activeName"
      @tab-click="tabhandleClick"
    >
      <el-tab-pane name="0" label="全部招标订单">
        <span slot="label">全部招标订单<i>( {{suppliercount.all}}</i> )</span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row style="font-size: 14px">
              <el-col :span="7">招标单</el-col>
              <el-col :span="7">报价截止时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6" >状态</el-col>
              <el-col :span="1">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  招标单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                     <p
                    :class="
                      item.status == 5
                        ? 'status'
                        :  item.status == 0 || item.status == 3 || item.status == 2
                        ? 'status1'
                        : item.status==1 ||item.status==4 || item.status==6  ||item.status==7 ?'status2':'status3'
                    "
                  >
                    {{ orderStatus(item.status) }}
                  </p>

                </el-col>
                <el-col :span="2">
                  <div class="last">

                    <p
                    class="status"
                      v-if="item.status == 0 || item.status == 1"
                      @click="handleChagne(item.id, 2)"
                    >
                      {{ item.status == 0 || item.status == 1 ? "修改" : "--" }}
                    </p>
                     <p

                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="1" label="审核中">
        <span slot="label">审核中<i>({{suppliercount.auditing}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status1">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p
                    class="status"
                      v-if="item.status == 0 || item.status == 1"
                      @click="handleChagne(item.id, 2)"
                    >
                      {{ item.status == 0 || item.status == 1 ? "修改" : "--" }}
                    </p>
                      <p
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="2" label="审核不通过">
        <span slot="label">审核不通过<i class="num">({{suppliercount.auditFailed}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status2">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p
                     class="status"
                      v-if="item.status == 0 || item.status == 1"
                      @click="handleChagne(item.id, 2)"
                    >
                      {{ item.status == 0 || item.status == 1 ? "修改" : "--" }}
                    </p>
                      <p

                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="3" label="报价中">
        <span slot="label">报价中<i>({{suppliercount.quoting}})</i> </span>

        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status1">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p class="status" @click="handleabandonment(item.id)">弃标</p>
                     <p
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="4" label="待选定">
        <span slot="label">待选定<i>({{suppliercount.waitChoosing}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status1">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p class="status" @click="handleabandonment(item.id)">弃标</p>
                      <p
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="5" label="已流标">
        <span slot="label">已流标<i>({{suppliercount.abortive}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status2">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p class="status" @click="handleabandonment(item.id)">弃标</p>
                    <p class="status" @click="handlerepelay(item.id, 4)">重新发起</p>
                      <p
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="6" label="已中标">
        <span slot="label">已中标<i>({{suppliercount.done}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex">
                    <p>{{ item.createTime }}</p>
                    <p>
                      采购单号：<span>{{ item.code }}</span>
                    </p>
                  </div>
                  <div style="display: flex; align-items: center">
                    <el-upload
                      v-if="!flage"
                      name="files"
                      class="upload-demo"
                      :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                      :on-success="handleAvatarSuccess"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                    >
                      <el-button
                      style="margin-right:20px"
                        class="onbtn"
                        v-if="!flage"
                        @click="handlecontract(item)"
                        size="small"
                        type="text"
                        ><i class="el-icon-upload2"></i> 上传合同</el-button
                      >
                    </el-upload>

                    <span style="color: #808080">|</span>

                    <el-button size="small" type="text" style="margin-left:20px">
                      <el-link
                        v-if="item.contractUrl !== null"
                        :underline="false"
                        type="primary"
                        style="font-size: 12px"
                        :href="item.contractUrl"
                        target="_blank"
                        ><i class="el-icon-download"></i>
                        下载合同
                      </el-link>
                      <span v-else style="font-size: 12px; color: #999"
                        >暂无合同下载</span
                      >
                    </el-button>
                  </div>
                </div>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                     <p
                     style="margin-left:10px"
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  <!-- flag:为true全部下单，无法继续下单 /fals可以下单 -->
                    <el-button v-if="item.flag== false"
                      size="small"
                      style="color: #c65442;padding-top:0px"
                      type="text"
                      @click="handleOrder(item.id)"
                    >
                      <i class="el-icon-shopping-cart-2"></i>
                      去下单
                    </el-button>

                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="7" label="已弃标">
        <span slot="label">已弃标<i>({{suppliercount.giveUp}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status2">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p
                    class="status"
                      v-if="item.status == 0 || item.status == 1"
                      @click="handleChagne(item.id, 2)"
                    >
                      {{ item.status == 0 || item.status == 1 ? "修改" : "--" }}
                    </p>
                     <p
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="8" label="已作废">
        <span slot="label">已作废<i>({{suppliercount.abandon}})</i> </span>
        <div class="tab_pane_content">
          <div class="search_box"></div>
          <div class="nave_content">
            <el-row>
              <el-col :span="7">采购单</el-col>
              <el-col :span="7">报价截至时间</el-col>
              <el-col :span="4">报价数量</el-col>
              <el-col :span="6">状态</el-col>
              <el-col :span="2">操作</el-col>
            </el-row>
          </div>
          <div v-for="(item, index) in orderInfoList" :key="index">
            <div class="nave_table">
              <div class="nave_table_top">
                <p>{{ item.createTime }}</p>
                <p>
                  采购单号：<span>{{ item.code }}</span>
                </p>
              </div>
              <el-row class="nave_table_bottom">
                <el-col :span="7">
                  <div>
                    <p class="over" :title="item.title">{{ item.title }}</p>

                  </div>
                </el-col>
                <el-col :span="7">
                  <p>{{ item.quoteEndTime }}</p>
                </el-col>
                <el-col :span="4">
                  <p>{{ item.quoteNum }}</p>
                </el-col>
                <el-col :span="6">
                  <p class="status2">{{ orderStatus(item.status) }}</p>

                </el-col>
                <el-col :span="2">
                  <div class="last">
                    <p class="status" @click="handlerepelay(item.id, 4)">重新发起</p>
                      <p
                    @click="handleDetail(item.id, item.status)"
                    class="Details status"
                  >
                    查看详情
                  </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="noData" v-if="orderInfoList.length == 0">
          您还没有相关订单。
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-row>
      <el-col :span="24" class="pagination">
        <!-- 分页组件 -->
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { releaselist, giveup, uploadContract,Suppliercount } from "@/api/xunyou";
export default {
  data() {
    return {
      type: JSON.parse(localStorage.getItem("userdata")).type, //1-供应商，3-采购商
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading: true,
      accountStatus: JSON.parse(localStorage.getItem("userdata")).accountStatus,
      url: "",
      listTotal:'',
      orderInfoList: [],
      waitpayValue: "",
      activeName: 0,
      type: JSON.parse(localStorage.getItem("userdata")).type,
      purchaserId: JSON.parse(localStorage.getItem("userdata")).bxmId,
      id: "",
      form: {
        title: "",
        userId: JSON.parse(localStorage.getItem("userdata")).userId,
        status: 0,
        pageNum: 1,
        pageSize: 10,
      },
      flage: false,
      suppliercount:{
        all:'',//全部
        quoting:'',//报价中
         abortive:'',//已流标
        abandon:'',//已作废
         auditFailed:'',//审核不通过
        quoting:'',//报价中
 waitChoosing:'',//待选定
        auditing:'',//审核中
        done:'',//已完成
        giveUp:'',//已弃标
      },

      // 分页参数
      pageparm: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    };
  },
  // 注册组件
  components: { Pagination },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.handleData(Number(this.activeName) - 1);
    this.handelcount()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //查询采购单数量
    handelcount(){
      Suppliercount({mid:this.userInfo.bxmId})
      .then(res=>{
       this.suppliercount=res.data
      })
    },
    handleAvatarSuccess(res, file) {
      this.url = res.url;

      if (this.type == 3) {
        //采购商
        uploadContract({
          purchaseOrderId: this.id,
          purchaserId: this.purchaserId,
          url: this.url,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success("合同上传成功");
          }
        });
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过10MB!");
      }
      return isLt2M;
    },
    //上传合同
    handlecontract(row) {
      this.id = row.id;
    },



    //弃标
    handleabandonment(id) {
      if (this.accountStatus == 1) {
        // 二次确认删除
        this.$confirm("确定要弃标吗？", "提示", {
          type: "warning",
        }).then(() => {
          giveup({ purchaseOrderId: id }).then((res) => {
            if ((res.code = 0)) {
              this.$message.success("弃标成功");
              this.$forceUpdate();
            }

            this.handleData(Number(this.activeName) - 1);
          });
        });
      } else {
        this.$message({
          type: "info",
          message: "该账户已被禁用,不可以进行弃标",
        });
      }
    },
    //重新发起
    handlerepelay(id, type) {
      if (this.accountStatus == 1) {
        // accountStatus==1启用，2为不启用
        this.$router.push(
          `/RapidProcurement?purchaseOrderId=${id}&type=${type}`
        );
      } else {
        this.$message({
          type: "info",
          message: "该账户已被禁用,不可以修改",
        });
      }
    },
    //   订单状态转换
    orderStatus(status) {
      switch (status) {
        case 0:
          return "审核中";
          break;
        case 1:
          return "审核不通过";
          break;
        case 2:
          return "报价中";
          break;
        case 3:
          return "待选定";
          break;
        case 4:
          return "已流标";
          break;
        case 5:
          return "已完成";
          break;
        case 6:
          return "已弃标";
          break;
        case 7:
          return "已作废";
          break;

        default:
          return "--";
      }
    },
    //查询数据
    handleData(status) {
      this.form.status = status == -1 ? "" : status;
      this.loading = false;
      releaselist(this.form).then((res) => {
        if (res.code == 0) {
          this.orderInfoList = res.rows;
          this.pageparm.total = res.total;
          // this.listTotal=res.total
        }
      });
    },
    //切换tab
    tabhandleClick(tab) {
      this.handleData(Number(this.activeName) - 1);
    },
    //查询
    Handlesearch() {
      // console.log(11);
      this.handleData(Number(this.activeName) - 1);
      this.$nextTick(() => {
        this.form.title = "";
      });
      //
    },
    // 分页插件事件
    callFather(parm) {
      this.form.pageNum = parm.currentPage;
      this.form.pageSize = parm.pageSize;
      this.handleData(Number(this.activeName) - 1);
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },

    handleDetail(id, status) {
      let type = this.orderStatus(status);
      if (this.type == 3) {
        //采购商
        this.$router.push(`/CorderDetails?id=${id}&status=${type}`);
      }
    },
    //去下单
    handleOrder(id) {
      if (this.accountStatus == 1) {
        this.$router.push(`/procurementOrder?id=${id}`);
      } else {
        this.$message({
          type: "info",
          message: "该账户已被禁用,不可以进行下单",
        });
      }
    },
    //修改
    handleChagne(id, type) {
      if (this.accountStatus == 1) {
        // accountStatus==1启用，2为不启用
        this.$router.push(
          `/RapidProcurement?purchaseOrderId=${id}&type=${type}`
        );
      } else {
        this.$message({
          type: "info",
          message: "该账户已被禁用,不可以修改",
        });
      }
    },

    // 搜索功能
    searchHandle(value) {
      // this.getshoworderList(this.activeName,value)
    },
  },
};
</script>

<style scoped lang="less">
.num{

}
.onbtn {
  padding: 0;
  height: 5px;
}
.over {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main_top {
  display: flex;
  justify-content: space-between;
  border-bottom: 2.5px dotted #e3e3e3;
  padding-bottom: 20px;

  .search {
    display: flex;
    .ipt {
      outline: none;
    }
    .btn {
      color: white;
      font-size: 14px;
      border: none;
      border-radius: 0 4px 4px 0;
      width: 80px;
      height: 40px;
      line-height: 20px;
      background-color: #c65442;
      padding: 10px;
    }
  }
}
.tabs {
  margin-top: 20px;
}

.rightaside {
}
// .rightaside{
//     background: white;
//     margin-left: 15px;
//     padding: 20px !important;
.rightaside_content {
  .headerTitle {
    font-size: 24px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    /deep/.el-tabs__header {

      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item /deep/.is-active {
        color: #c65442 !important;

        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }
  .search_box {
    text-align: right;
    margin-bottom: 10px;
    .input-with-select.el-input.el-input-group.el-input-group--append {
      width: 40%;
    }
  }
  .redBorder {
    border: 1px solid #ff6700 !important;
  }
  .orderbox_info {
    // padding: 20px;
    // box-sizing: border-box;
    margin-bottom: 10px;
    border: 1px solid#ccc;
    .orderbox_info_header {
      padding: 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      p {
        font-size: 16px;
        color: #ff6700;
        margin-bottom: 5px;
      }
      .order_money i {
        font-size: 20px;
        color: #ff6700;
      }
    }
    .order_goods_whole {
      padding: 20px;
      box-sizing: border-box;
      .order_goods {
        margin-bottom: 20px;
        .order_Info_item {
          margin-left: 20px;
        }
      }
      button.el-button.buttonStyle {
        padding: 6px 30px;
        font-size: 12px;
        margin-bottom: 6px;
        margin-left: 0;
      }
      .dangerBg.buttonStyle {
        background-color: #ff6700;
        border-color: #ff6700;
      }
      .el-button--danger.is-plain {
        background: white;
      }
      .el-button--danger:focus,
      .el-button--danger:hover {
        color: white;
        background: #f56c6c;
      }
    }
  }
}

// }
.pagination {
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #c65442;
    color: #fff;
    width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next,
  /deep/.el-pagination.is-background .btn-prev,
  /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
.nave_content {
  // display: flex;
  // justify-content: space-around;
padding: 10px 0;
padding-left: 35px;
  height: 20px;
  line-height: 20px;
  background-color: #eef1f6;
}
.nave_table {
  margin: 15px 0;
  .nave_table_top {
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid gray;
    border-bottom: none;
    display: flex;
    align-items: center;
    background-color: #eef1f6;
    p {
      margin-right: 100px;
      color: gray;
      span {
        color: #000;
      }
    }
  }
  .nave_table_bottom {
    font-size: 14px;
    padding: 10px 10px;
    padding-bottom: 0;
    border: 1px solid gray;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      display: flex;
      flex-direction: column;
      p {
        height: 22px;
        line-height: 22px;
        padding-bottom: 5px;
      }
      .Details {
        cursor: pointer;
      }
    }
    .last {
      // margin-right: 30px;
      color: gray;
      cursor: pointer;
    }
  }
}
.noData {
  text-align: center;
  height: 200px;
  line-height: 200px;
}
.status {
  color: #000;
}
.status1 {
  color: orange;
}
.status2 {
  color: red;
}
.status3 {
  color: gray;
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/mypurchase.vue